import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LightLogo from '../../static/landing/Light.png';
import CloseMenu from '../../static/landing/blackclosemenu.svg';

export default function LandingMobileNavbar({ loggedIn, mobileActive, handleMobileClose }) {
    const location = useLocation();
    const noLogin = ["/login", "/password", "/resetpassword", "/newpassword", "/passwordsaved"];
    return (
        <div className={`LandingMobileNavbar ${mobileActive ? 'mobile-active' : ''}`}>
            <div className="top">
                <Link
                to="/"
                onClick={handleMobileClose}
                className="logo-wrapper">
                    <img 
                    className="mobile-logo"
                    src={LightLogo} 
                    alt="Salewave Logo"/>
                </Link>

                <img
                className="mobile-close-menu" 
                onClick={handleMobileClose}
                src={CloseMenu} alt="Close Menu"/>
            </div>

            <ul className="mobile-nav-tabs">
                <li>
                    <Link 
                    onClick={handleMobileClose}
                    to={{
                    pathname: "/",
                    state: {
                        goToFeatures: true
                    }}}>Features</Link>
                </li>
                <li>
                    <Link 
                    onClick={handleMobileClose}
                    to="/pricing">Pricing</Link>
                </li>
                <li className="space-down">
                    <Link 
                    onClick={handleMobileClose}
                    to="/faq">FAQ</Link>
                    </li>
                {
                    !loggedIn && !noLogin.find(path => path === location.pathname) &&
                    <li className="login">
                        <Link
                        to="/login"
                        onClick={handleMobileClose}
                        className="mobile-login-button" 
                        >Login</Link>
                    </li>
                }
                {
                    !loggedIn && location.pathname !== "/register" &&
                    <li>
                        <Link
                        to="/register"
                        onClick={handleMobileClose}
                        className="mobile-register-button"
                        >Get Access</Link>
                    </li>
                }
                {
                    loggedIn &&
                    <li>
                        <Link
                        onClick={handleMobileClose}
                        to="/connectdepop"
                        className="mobile-register-button"
                        >Dashboard</Link>
                    </li>
                }

            </ul>
        </div>
    )
}